import { initVideoListener, initEmbedListener } from "@api/utils_2020";

export default () => {

    $('#modal-casacor').modal('show');
    initVideoListener();
    initEmbedListener();
}